package com.patronat.top.ui.atoms

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.MineShaft200
import com.patronat.top.ui.theme.Primary500
import com.patronat.top.ui.theme.White

@Composable
fun AppSwitch(
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true
) {
    val interactionSource = remember { MutableInteractionSource() }
    val trackWidth = 36.dp
    val trackHeight = 20.dp
    val thumbSize = 16.dp
    val padding = 2.dp
    val maxOffset = trackWidth - thumbSize - padding * 2

    val trackColor by animateColorAsState(
        targetValue = when {
            !enabled -> MineShaft100
            checked -> Primary500
            else -> MineShaft100
        },
        animationSpec = tween(durationMillis = 150),
        label = "SwitchTrackColor"
    )
    val borderColor by animateColorAsState(
        targetValue = when {
            !enabled -> MineShaft100
            checked -> Primary500
            else -> MineShaft200
        },
        animationSpec = tween(durationMillis = 150),
        label = "SwitchBorderColor"
    )
    val thumbOffset by animateDpAsState(
        targetValue = if (checked) maxOffset else 0.dp,
        animationSpec = tween(durationMillis = 150),
        label = "SwitchThumbOffset"
    )
    val thumbColor = if (enabled) White else MineShaft200

    Box(
        modifier = modifier
            .size(trackWidth, trackHeight)
            .background(trackColor, RoundedCornerShape(trackHeight / 2))
            .border(1.dp, borderColor, RoundedCornerShape(trackHeight / 2))
            .clickable(
                enabled = enabled,
                interactionSource = interactionSource,
                indication = null
            ) {
                onCheckedChange(!checked)
            }
    ) {
        Box(
            modifier = Modifier
                .offset(x = thumbOffset + padding, y = padding)
                .size(thumbSize)
                .background(thumbColor, CircleShape)
        )
    }
}
